import styled from 'styled-components';
// import palette from '../../lib/styles/palette';

import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { changeField, initializeInput } from '../../modules/conveyor/conveyorWriteSlice';

const ConveyorTypeSelectionRadioButtons = ({ conveyorType }) => {
    const dispatch = useDispatch();

    const [newType, setNewType] = useState(conveyorType || 'Troughed');

    const handleChange = (e) => {
        setNewType(e.target.value);
    };

    useEffect(() => {
        dispatch(
            changeField({
                key: 'conveyorType',
                value: newType
            }),
        );
        dispatch(
            initializeInput(),
        );
    }, [dispatch, newType]);

    const typeArray = ['Troughed', 'Pipe', 'Return Pipe'/*, 'Steep Angle', 'Sandwich' */];

    return (
        <ConveyorTypeSelectionRadioButtonsBlock>
            <form>
                <RadioButtons newType={newType} handleChange={handleChange} typeArray={typeArray} />
            </form>
        </ConveyorTypeSelectionRadioButtonsBlock>
    );
};

export default ConveyorTypeSelectionRadioButtons;

const RadioButtons = ({ newType, handleChange, typeArray }) => {
    return (
        <div style={{ marginTop: '1rem' }}>
            {typeArray.map((type, index) => (
                <label key={index} style={{ marginRight: '1rem' }}>
                    <input type="radio" value={type} checked={type === newType} onChange={handleChange} />
                    {type}
                </label>
            ))}
        </div>
    );
};

const ConveyorTypeSelectionRadioButtonsBlock = styled.div``;
